// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + {"337":"c6da0cfda88eaf915494","936":"33443b31c0161e21fe70"}[chunkId] + ".js";
};